import { render, staticRenderFns } from "./ShipperGroupSelect.vue?vue&type=template&id=2a1d96c2"
import script from "./ShipperGroupSelect.vue?vue&type=script&lang=js"
export * from "./ShipperGroupSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports